/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
var C;!function(C){C[C.ASYNC=0]="ASYNC",C[C.SYNC=1]="SYNC"}(C||(C={}));export{C as UpdatePolicy};
